import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  DirectorReportEditAccess,
  GetDirectorReport,
  GetDirectorReportEmployee
} from "../../Repository/Api";
import { NonEmptyValidation } from "../../Store/validate";
import { FinancialMonthOptions, FinancialYearOptions, FinancialYearView, IsOldReportYear, MonthView } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";

const DirectorReportlist = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();

  useEffect(() => {
    getEmployeeList();
  }, []);

  const initialApplyState = {
    employee_ids: [],
    academic_year: [],
    months: [],
  };

  const [apply, setApply] = useState(initialApplyState);

  const [report, setReport] = useState({});
  const [validation, setValidation] = useState({});
  const [employee, setEmployee] = useState([]);
  const [editReport, setEditReport] = useState({});
  const [editReportModel, setEditReportModel] = useState(false);

  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    setEditReport({ ...editReport, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getEmployeeList = async () => {
    const response = await GetDirectorReportEmployee(token);
    if (response && response.statusCode === 200) {

      let employee = response?.data?.map((label) => ({
        label: label.name,
        value: label.id,
      }));
      employee = [{ label: "All", value: "all" }, ...employee];
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.employee_ids = NonEmptyValidation(apply?.employee_ids);
    validate.academic_year = NonEmptyValidation(apply?.academic_year);
    if (!IsOldReportYear(apply)) {
      validate.months = NonEmptyValidation(apply?.months);
    }

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        academic_year: apply?.academic_year,
        employee_ids: apply?.employee_ids?.map((date) => date.value),
        months: apply?.months?.map((date) => date.value),
      };
      const response = await GetDirectorReport(Payload, token);
      if (response && response.statusCode === 200) {
        setReport(response.data?.faculty_activity_report);
        successMsg(response.message);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleUpdateEditOption = async (e) => {
    e.preventDefault();
    let validate = {};
    validate.editable = NonEmptyValidation(apply?.editable);
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        id: editReport.id,
        editable: editReport.editable,
      };
      const response = await DirectorReportEditAccess(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setEditReport({});
        setEditReportModel(false);
        e.target.reset();
        getEmployeeList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-6">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Director/Directoroverallreport");
                    }}
                  >
                    Generate Appraisal Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-12 p-0">
                    <h6 className="labeltitle">Appraisal Report</h6>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="labeltext"> Employee Name *</label>
                    <div>
                      <ReactSelect
                        isMulti
                        value={apply?.employee_ids}
                        onChange={(e) => {
                          setData(e, "employee_ids");
                        }}
                        options={
                          apply?.employee_ids?.some((v) => v?.value === "all")
                            ? [{ label: "All", value: "all" }]
                            : employee
                        }
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.employee_ids?.message
                        ? `Employee ${validation?.employee_ids?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <div>
                      <ReactSelect
                        isMulti={false}
                        value={{
                          label: apply.academic_year,
                          value: apply.academic_year,
                        }}
                        onChange={(selectedOption) =>
                          setData(selectedOption.value, "academic_year")
                        }
                        options={FinancialYearOptions()}
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  {!IsOldReportYear(apply) && (
                    <div className="col-lg-3">
                      <label className="labeltext"> Month *</label>
                      <div>
                        <ReactSelect
                          isMulti
                          value={apply?.months}
                          onChange={(e) => {
                            setData(e, "months");
                          }}
                          options={
                            apply?.months?.some((v) => v?.value === "all")
                              ? [{ label: "All", value: "all" }]
                              : FinancialMonthOptions(apply)
                          }
                        />
                      </div>
                      <small className="validationerror">
                        {validation?.months?.message
                          ? `Month ${validation?.months?.message}`
                          : ""}
                      </small>
                    </div>
                  )}
                  <div className="col-lg-3 mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Get Report
                    </button>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Employee Name</th>
                      <th scope="col">Year</th>
                      <th scope="col">Month</th>
                      <th scope="col">Application</th>
                      <th scope="col">Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report.length > 0 ? (
                      report &&
                      report.map((apply, index) => (
                        <tr key={index}>
                          <td>{apply?.name ? apply?.name : "-"}</td>
                          <td>{apply?.academic_year ? FinancialYearView(apply?.month, apply?.academic_year) : "-"}</td>
                          <td>{apply?.month ? MonthView(apply?.month) : "-"}</td>
                          <td className="viewoption">
                            <Link
                              to={`/app/Director/Directorreportspecificview/${apply?.id}`}
                            >
                              View
                            </Link>
                          </td>
                          <td
                            className="resetbuttonoption"
                            onClick={() => {
                              setEditReportModel(true);
                              setEditReport(apply);
                            }}
                          >
                            <span className="material-symbols-outlined">
                              edit
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <div> No Data Found</div>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        {/* Reset Password Model */}
        <CustomModal
          open={editReportModel}
          onClickOutside={() => {
            setEditReportModel(false);
            setApply({});
          }}
        >
          <form
            onSubmit={(e) => {
              handleUpdateEditOption(e);
            }}
          >
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Edit Access</h5>
              </div>
              <div className="modal-body p-0">
                <div className="container">
                  <div className="row mt-2">
                    <div className="col-lg-8 mx-auto ms-auto">
                      <div className="inputspace">
                        <label className="labeltext mb-3">Edit Access</label>
                        <select
                          className="fieldinput"
                          defaultValue={editReport?.editable}
                          onChange={(e) => setData(e.target.value, "editable")}
                        >
                          <option value="">Select Option</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                        <small className="validationerror">
                          {validation?.editable?.message
                            ? `Access ${validation?.editable?.message}`
                            : ""}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setEditReportModel(false);
                      setValidation({});
                      setEditReport({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 submit-btn">
                    Access to Edit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default DirectorReportlist;
